var initHotspots = function() {
  var aria_texts = general.decodeLocale(window.kef.assets.aria.texts);
  $('.kef-hotspots').append('<div class="kef-hotspot-overlay"></div>');
  $('.kef-hotspot').each(function() {
    // $(this).append('<div class="kef-hotspot-overlay"></div>');
    $('> .kef-hotspot-button', this).attr('aria-label', aria_texts.explore_more);
    $('> .kef-hotspot-content', this).append('<button type="button" class="kef-hotspot-close"></button>');
    $('> .kef-hotspot-content .kef-hotspot-close', this).attr('aria-label', aria_texts.close);
    $('> .kef-hotspot-button', this).removeClass('active');
  });

  $('.kef-hotspots')
    .on('mouseenter', '.kef-hotspot-button', function() {
      $('.kef-hotspot-button').removeClass('first-active');
    })
    .on('click', '.kef-hotspot-button', function() {
      $(this).addClass('active');
      $('body').toggleClass('hotspot-overlay-active');
    })
    .on('click', '.kef-hotspot-close', function() {
      $('.kef-hotspot-button').removeClass('active');
      $('body').removeClass('hotspot-overlay-active');
    })
    .on('click', '.kef-hotspot-overlay', function() {
      $('.kef-hotspot-button').removeClass('active');
      $('body').removeClass('hotspot-overlay-active');
    });
}
initHotspots();